// extracted by mini-css-extract-plugin
export default {"recos":"p8-z","productCardOverride":"q8-z","rowHasBadge":"r8-z"};